import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
	// onChange callback (field, value) => do whatever you want; field/value is for DelayedInput
	onChange: PropTypes.func.isRequired,

	// the value to show
	value: PropTypes.string.isRequired,
};

const defaultProps = {};

export default class FilterDetailInput extends React.Component {
	render() {
		return <input
				type="text"
				placeholder="Filter"
				value={this.props.value}
				onChange={e => this.props.onChange(undefined, e.target.value)}
			/>;
	}
}

FilterDetailInput.defaultProps = defaultProps;
FilterDetailInput.propTypes = propTypes;